import { useEffect, useRef, useState } from "react";
import teamImg from "../assets/team.jpg"; // ✅ import from src/assets

/**
 * Optimized Image Component
 * Uses a blurred placeholder until the full image is loaded
 */
const ImageOptimized = ({ alt, className = "" }) => {
  const [loaded, setLoaded] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const img = containerRef.current.querySelector(".real-img");
    if (!img) return;
    if (img.complete) setLoaded(true);
    img.onload = () => setLoaded(true);
  }, []);

  return (
    <div
      ref={containerRef}
      className={`img-wrap ${loaded ? "loaded" : ""} ${className}`}
      style={{ position: "relative", overflow: "hidden" }}
    >
      {/* Blurred placeholder */}
      <img
        className="img-placeholder"
        src={teamImg}
        alt=""
        aria-hidden="true"
        style={{
          filter: "blur(20px)",
          transform: "scale(1.05)",
          width: "100%",
          height: "auto",
          position: "absolute",
          top: 0,
          left: 0,
          transition: "opacity 0.5s ease",
          opacity: loaded ? 0 : 1,
        }}
      />

      {/* Real image */}
      <img
        className="real-img"
        src={teamImg}
        alt={alt}
        loading="lazy"
        style={{
          width: "100%",
          height: "auto",
          position: "relative",
          transition: "opacity 0.5s ease",
          opacity: loaded ? 1 : 0,
        }}
      />
    </div>
  );
};

export default ImageOptimized;
